import cn from 'classnames';
import React from 'react';

export interface ContentContainerProps {
  backgroundColor: 'gray' | 'white' | string;
  className?: string;
  disableSpacing?: boolean;
}

const ContentContainer: React.FC<
  React.PropsWithChildren<ContentContainerProps>
> = ({ children, backgroundColor, disableSpacing = false, className }) => {
  const hasCustomBackground =
    backgroundColor.charAt(0) === '#' || backgroundColor.charAt(0) === 'r';

  return (
    <div
      className={cn(
        disableSpacing ? '' : 'px-6 py-8 md:px-8 md:py-12',
        (backgroundColor === 'gray' || backgroundColor === 'grey') &&
          'bg-background-default',
        backgroundColor === 'white' && 'bg-other-white',
        className
      )}
      style={hasCustomBackground ? { backgroundColor } : {}}
    >
      <div className="container mx-auto px-0">{children}</div>
    </div>
  );
};

export default ContentContainer;
